import React from 'react';
import PropTypes from 'prop-types';

export const Email = ({ fill, title }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" className="social-icon icon-email">
    <title>{title}</title>
    <path
      fill={fill}
      d="M29 24.1H6.95v-1.4H27.6V7.3H2.4v15.4h2.1v1.4H1V5.9h28v18.2zm-14-5.8L4.4 9.23l.9-1.06 9.7 8.28 9.6-8.28.92 1.06L15 18.3z"
    />
  </svg>
);

Email.defaultProps = { fill: '#000', title: 'Email' };
Email.propTypes = { fill: PropTypes.string, title: PropTypes.string };

export const Facebook = ({ fill }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" className="social-icon icon-facebook">
    <title>Facebook</title>
    <path
      fill={fill}
      d="M29 15a14 14 0 1 0-16.19 13.83V19H9.26v-4h3.55v-3.08c0-3.5 2.1-5.45 5.3-5.45a21.53 21.53 0 0 1 3.13.27v3.45h-1.76a2 2 0 0 0-2.28 2.19V15h3.88l-.62 4H17.2v9.78A14 14 0 0 0 29 15z"
    />
  </svg>
);

Facebook.defaultProps = { fill: '#000' };
Facebook.propTypes = { fill: PropTypes.string };

export const Twitter = ({ fill }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" className="social-icon icon-twitter">
    <title>Twitter</title>
    <path
      fill={fill}
      d="M9.78 26.52c10.7 0 16.55-8.87 16.55-16.55v-.75a11.84 11.84 0 0 0 2.9-3 11.61 11.61 0 0 1-3.34.92 5.84 5.84 0 0 0 2.55-3.24 11.66 11.66 0 0 1-3.69 1.41 5.82 5.82 0 0 0-9.91 5.31 16.52 16.52 0 0 1-12-6.08 5.82 5.82 0 0 0 1.8 7.77A5.77 5.77 0 0 1 2 11.58v.07a5.82 5.82 0 0 0 4.67 5.7 5.81 5.81 0 0 1-2.63.1 5.82 5.82 0 0 0 5.44 4A11.67 11.67 0 0 1 2.25 24a11.84 11.84 0 0 1-1.38-.08 16.47 16.47 0 0 0 8.92 2.61"
    />
  </svg>
);

Twitter.defaultProps = { fill: '#000' };
Twitter.propTypes = { fill: PropTypes.string };

export const WhatsApp = ({ fill, title }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" className="social-icon icon-whatsapp">
    <title>{title}</title>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M24.23 5.78A12.88 12.88 0 0 0 4 21.32L2.13 28 9 26.2a12.87 12.87 0 0 0 6.15 1.57 12.88 12.88 0 0 0 9.11-22zm-9.1 19.82a10.69 10.69 0 0 1-5.45-1.5l-.4-.23-4.05 1.07 1.08-4-.25-.4a10.7 10.7 0 1 1 9.07 5zm5.87-8l-2.2-1c-.3-.06-.5-.16-.72.16s-.83 1-1 1.26-.38.24-.7.08a8.79 8.79 0 0 1-2.59-1.6A9.7 9.7 0 0 1 12 14.21c-.2-.32 0-.5.14-.66l.48-.56a2.2 2.2 0 0 0 .32-.54.59.59 0 0 0 0-.56c-.08-.16-.72-1.75-1-2.4s-.53-.54-.72-.55h-.62a1.18 1.18 0 0 0-.86.4A3.61 3.61 0 0 0 8.58 12a6.26 6.26 0 0 0 1.31 3.33 14.34 14.34 0 0 0 5.5 4.86 18.48 18.48 0 0 0 1.83.68 4.41 4.41 0 0 0 2 .13 3.31 3.31 0 0 0 2.17-1.53 2.69 2.69 0 0 0 .22-1.47c-.08-.18-.3-.26-.6-.42z"
    />
  </svg>
);

WhatsApp.defaultProps = { fill: '#000', title: 'WhatsApp' };
WhatsApp.propTypes = { fill: PropTypes.string, title: PropTypes.string };

export const Instagram = ({ fill }) => (
  <svg width="30" height="30" viewBox="0 0 28 28" className="social-icon icon-whatsapp">
    <title>Instagram</title>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M8.12,0H19.88A8.13,8.13,0,0,1,28,8.12V19.88A8.13,8.13,0,0,1,19.88,28H8.12A8.13,8.13,0,0,1,0,19.88V8.12A8.13,8.13,0,0,1,8.12,0M7.84,2.8a5,5,0,0,0-5,5V20.16a5,5,0,0,0,5,5H20.16a5,5,0,0,0,5-5V7.84a5,5,0,0,0-5-5H7.84M21.35,4.9A1.75,1.75,0,1,1,19.6,6.65,1.75,1.75,0,0,1,21.35,4.9M14,7a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0,2.8A4.2,4.2,0,1,0,18.2,14,4.19,4.19,0,0,0,14,9.8Z"
    />
  </svg>
);

Instagram.defaultProps = { fill: '#000' };
Instagram.propTypes = { fill: PropTypes.string };
